'use strict';
window.uomedia = window.uomedia || {};
var $clamp = $clamp || null;
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadHidden = false;
(function ($) {
  // Scripts to fire on every page

  $('.clamped-title').each(function () {
    var lines = $(this).hasClass('highlighted') ? 4 : 3;
    $clamp(this, { clamp: lines, useNativeClamp: false, truncationChar: '&nbsp;', truncationHTML: '&hellip;' });
  });

  let oneTrustLoaded = false;
  let oneTrustInterval;
  const oneTrustIcon = () => {
    // one trust not loaded
    if (!window.OneTrust) {
      return;
    } else {
      oneTrustLoaded = true;
      clearInterval(oneTrustInterval);
      if (window.OneTrust.getGeolocationData().country === 'US') {
        $('#ot-privacy-icon').removeClass('d-none');
      }
    }
  };

  $(window).load(function () {
    oneTrustInterval = setInterval(oneTrustIcon, 500);
  });

})(jQuery);
